import { MAIN_NAVIGATION_ITEMS } from "@/router/constants";
import Offers from "@/views/offers/Offers.vue";
import OfferDetails from "@/views/offers/components/Offer.vue";
import OfferDocument from "@/views/offers/components/OfferDocument/OfferDocument.vue";
import ProofOfId from "@/views/offers/components/compliances/ProofOfId.vue";
import DBS from "@/views/offers/components/compliances/DBS.vue";
import RightToWork from "@/views/offers/components/compliances/RightToWork.vue";
import References from "@/views/offers/components/compliances/References.vue";

const { OFFERS } = MAIN_NAVIGATION_ITEMS;

export const offersRouter = [
  {
    path: "/offers",
    name: OFFERS,
    component: Offers
  },
  {
    path: "/offers/:id",
    name: "offerDetails",
    component: OfferDetails
  },
  {
    path: "/offers/:id/document/:documentId",
    name: "offerDocument",
    component: OfferDocument
  },
  {
    path: "/offers/:id/proof-of-id",
    name: "proofOfId",
    component: ProofOfId
  },
  {
    path: "/offers/:id/dbs",
    name: "dbs",
    component: DBS
  },
  {
    path: "/offers/:id/right-to-work",
    name: "rtw",
    component: RightToWork
  },
  {
    path: "/offers/:id/references",
    name: "offer-references",
    component: References
  }
];
